import React, { useState } from "react";
import { useDialogTriggers } from "../hooks/use_dialog_triggers";
import { CloseIcon, DeweyLogo, RightBackText } from "../icons";
import DeweyWorkdmark from "../icons/dewey_workdmark";

type AppErrorProps = {
  triggerId: string | undefined;
};

export default function AppError({ triggerId }: AppErrorProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dialogRef = useDialogTriggers({ isOpen, open: () => setIsOpen(true), triggerId });

  return (
    <dialog
      id="dewey--search--dialog"
      ref={dialogRef}
      onClose={() => {
        setIsOpen(false);
      }}
      onClick={(event) => {
        // Close the dialog if the user clicks outside the dialog
        if (event.target instanceof HTMLElement && event.target.id === "dewey--search--dialog") {
          setIsOpen(false);
        }
      }}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        width: "100%",
        height: "100%",
        maxWidth: "100%",
        maxHeight: "100%",
        zIndex: 2147483647,
        margin: 0,
        padding: 0,
        boxSizing: "border-box",
        outline: "none",
        border: "none",
        background: "none",
      }}
    >
      {/* Wrapper is needed to properly detect clicks outside the dialog */}
      {isOpen && (
        <div
          style={{
            position: "relative",
            backgroundColor: "#FFFBF3",
            color: "black",
            height: "44rem",
            maxHeight: "100%",
            boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
            padding: 0,
            margin: 0,
            boxSizing: "border-box",
            outline: "none",
            border: "none",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-start",
              width: "calc(100% - 2rem)",
              maxWidth: "64rem",
              padding: "0 1rem",
            }}
          >
            <button
              type="button"
              onClick={() => setIsOpen(false)}
              style={{
                margin: 0,
                padding: 0,
                background: "none",
                border: "none",
                outline: "none",
                cursor: "pointer",
                marginTop: "3rem",
                marginBottom: "4rem",
                alignSelf: "flex-end",
              }}
            >
              <CloseIcon />
            </button>
            <DeweyLogo
              width={66}
              height={64}
            />
            <div style={{ height: "1rem" }} />
            <RightBackText style={{ maxWidth: "100%" }} />
            <p
              style={{
                fontSize: "1rem",
                fontFamily: "system-ui, sans-serif",
                fontWeight: 400,
                padding: 0,
                paddingTop: "0.25rem",
                margin: 0,
                textAlign: "center",
              }}
            >
              Dewey is being updated and will be available again shortly.
            </p>
            <p
              style={{
                fontSize: "0.875rem",
                fontFamily: "system-ui, sans-serif",
                fontWeight: 400,
                padding: 0,
                margin: 0,
                marginTop: "4rem",
                textAlign: "center",
              }}
            >
              For more information, visit our{" "}
              <a
                style={{ color: "#000000", textDecoration: "underline", padding: 0, margin: 0 }}
                href="https://status.askdewey.com/"
              >
                status page
              </a>
              .
            </p>
          </div>
          <div
            style={{
              position: "absolute",
              bottom: "0.75rem",
              left: "1.5rem",
              padding: 0,
              margin: 0,
            }}
          >
            <a
              href="https://askdewey.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-start",
                gap: "0.375rem",
                color: "#000000",
                textDecoration: "none",
                fontSize: "0.625rem",
                fontFamily: "system-ui, sans-serif",
                fontWeight: 400,
                padding: 0,
                margin: 0,
              }}
            >
              <span style={{ opacity: 0.6, paddingBottom: "0.25rem", marginTop: "-1px" }}>Powered by</span>
              <DeweyWorkdmark />
            </a>
          </div>
        </div>
      )}
    </dialog>
  );
}
